import React, { useEffect } from "react";

/**
 * Ford portal SSO entry point. Forwards to the API auth handler while
 * preserving the public /ford/authentication URL registered in Entra.
 */
const FordAuthentication: React.FunctionComponent = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isCallback = params.has("code") || params.has("error");
    const apiPath = isCallback ? "/api/ford/authentication/callback" : "/api/ford/authentication";
    window.location.replace(`${apiPath}${window.location.search}`);
  }, []);

  return <div>Signing you in to InsightBM...</div>;
};

export default FordAuthentication;
